import { useRef} from 'react';
// import logo from './logo.png';
// import office1 from './images/office1.png';
import './App.css';
// import Schedule from './schedule';
// import { useNavigate } from 'react-router-dom';
// import redbird1 from './images/redbird1.jpeg';
// import vid1 from './videos/vid1.mp4';



function Contact() {

  var moreTarget = useRef(null);

  function scrollTo(refTarget: any) {
    refTarget.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  return (
    <>
      {/* <div className="landingPageItemCenter" style={{margin:0, padding:0,}}>
        <video src={"/videos/sim1.mp4"} autoPlay muted style={{zIndex:"-3"}}></video>
        <button onClick={()=> scrollTo(moreTarget) }style={{position:"absolute", bottom:"20%",zIndex:"0"}}>See More</button>
      </div> */}
      <div className="contactContainer" style={{height:"100%"}}>
        <h1>Contact Us</h1>
        <h2> If you have any questions or comments, please contact us via email, or send us a message using our early access form.</h2>
        {/* <form style={{ backgroundColor:"#038df6",maxWidth:"70%",padding:10}} className="contactForm" target="_blank" action="https://formsubmit.co/60aa8631f967c0c246cc6ae95db8d95b" method="POST">
          <div style={{ display: "grid", gridTemplateRows: "auto-fit", minWidth:"90%",margin:0,padding:0,gap:20 }} className="form-group">
            <div className="col">
              <input style={{fontSize:"1.3rem",fontWeight: "bolder"}}type="text" name="name" className="form-control" placeholder="Full Name" required />
            </div>
            <div className="col">
              <input style={{fontSize:"1.3rem",fontWeight: "bolder"}} type="email" name="email" className="form-control" placeholder="Email Address" required />
            </div>
          </div>
          <div style={{width: "90%" }} className="form-group">
            <textarea style={{ width: "100%",fontSize:"1.2rem" }} placeholder="Your Message" className="form-control" name="message" rows={20} required></textarea>
          </div>
          <button type="submit" className="btn btn-lg btn-dark btn-block">Submit Form</button>
        </form> */}
      </div>
    </>

  );
}

export default Contact;
